export const EmailLogin = {
  SET_EMAIL: 'SET_EMAIL',
  SET_PASSWORD: 'SET_PASSWORD',
  LOGIN_EMAIL: 'LOGIN_EMAIL',
  RECEIVE_EMAIL_LOGIN: 'RECEIVE_EMAIL_LOGIN'
}

export const FacebookLogin = {
  HANDLE_FACEBOOK_LOGIN_BUTTON: 'HANDLE_FACEBOOK_LOGIN_BUTTON',
  FACEBOOK_LOGIN: 'FACEBOOK_LOGIN',
  RECEIVE_FACEBOOK_LOGIN: 'RECEIVE_LOGIN',
}

export const Signup = {
  SIGN_UP_SET_EMAIL: 'SIGN_UP_SET_EMAIL',
  SIGN_UP_SET_PASSWORD: 'SIGN_UP_SET_PASSWORD',
  SIGN_UP_SET_NAME: 'SIGN_UP_SET_NAME',
  SIGN_UP_SET_LAST_NAME: 'SIGN_UP_SET_LAST_NAME',
  SIGN_UP_PHONE: 'SIGN_UP_PHONE',
  SIGN_UP: 'SIGN_UP',
  RECEIVE_SIGN_UP: 'RECEIVE_SIGN_UP',
}

export const Recover = {
  SET_STEP: 'recover/SET_STEP',
  STEP_1_SET_EMAIL: 'recover/STEP_1_SET_EMAIL',
  STEP_1_SEND_CODE: 'recover/STEP_1_SEND_CODE',
  STEP_1_RECEIVE_CODE: 'recover/STEP_1_RECEIVE_CODE',
  STEP_2_SET_EMAIL: 'recover/STEP_2_SET_EMAIL',
  STEP_2_SET_PASSWORD: 'recover/STEP_2_SET_PASSWORD',
  STEP_2_SET_CODE: 'recover/STEP_2_SET_CODE',
  STEP_2_SEND_NEW_PASSWORD: 'recover/STEP_2_SEND_NEW_PASSWORD',
  STEP_2_RECEIVE_NEW_PASSWORD: 'recover/STEP_2_RECEIVE_NEW_PASSWORD',
}



// WEBPACK FOOTER //
// ./src/state/login/types.js